import styled from 'styled-components'

const Separator = styled.div`
	background: ${props => props.theme.backgroundVeryLight};
	height: 1px;
	margin: 0.5rem 0;
`

export default Separator
